import { onBeforeUnmount, onMounted } from 'vue';

const callbackSet = new Set<(event: MouseEvent) => void>();
let isTouchScreen = false;

if (typeof window !== 'undefined') {
  document.body.addEventListener('mousemove', registerMove, { passive: true });
  window.addEventListener(
    'touchstart',
    () => {
      isTouchScreen = true;
    },
    { passive: true }
  );
}

function registerMove(event: MouseEvent) {
  if (isTouchScreen) {
    return;
  }

  callbackSet.forEach((callback) => {
    callback?.(event);
  });
}

export function onMouse(callback: (mouseEvent: MouseEvent) => void) {
  callbackSet.add(callback);
  return () => {
    callbackSet.delete(callback);
  };
}

export function useOnMouse(callback: (mouseEvent: MouseEvent) => void) {
  onMounted(() => {
    callbackSet.add(callback);
  });

  onBeforeUnmount(() => {
    callbackSet.delete(callback);
  });
}
